import moment from "moment";
import { Fragment } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { timeDisplayFormat } from "../../utils/utils";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";

const MonthCalendarSchedules = ({ daySchedules, onScheduleClick }) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  return (
    <Fragment>
      {daySchedules
        .filter((daySchedule) => {
          if (user?.role === "teacher") {
            return daySchedule.status !== "pending";
          }
          return true;
        })
        .map((item, index) => {
          const time = moment.tz(
            item.scheduledDate + "T" + item.scheduledStartTime + ".000",
            item.originalScheduledTimezoneName,
          );
          const timeStart = time.tz(user.timezone).format(timeDisplayFormat(user?.timeDisplayFormat));
          const timeEnd = time.tz(user.timezone).add(30, "minutes").format(timeDisplayFormat(user?.timeDisplayFormat));
          if (index < 2) {
            return (
              <div
                key={item.id}
                className={`calendarSchedule
                  ${item.status === "done" ? "done" : ""}
                  ${item.status === "noShow" ? "noShow" : ""}
                  ${item.status === "pending" ? "pending" : ""}
                  ${item.status === "canceled" ? "outLimit" : ""}
                  ${item.status === "canceledFree" ? "canceled" : ""}`}
                onClick={(e) => onScheduleClick(e, item.id)}
              >
                <p className="calendarScheduleTime">
                  {`${timeStart} - ${timeEnd}`}{" "}
                  {t(decryptIfEncrypted(item?.lingoLanguage?.language?.name).toUpperCase())}{" "}
                  {item.target === "demo" && item.target.toUpperCase()}
                </p>
              </div>
            );
          }
        })}
      {daySchedules.length > 2 && (
        <p className="calendarMoreSchedules">
          {`+ ${daySchedules.length - 2} ${daySchedules.length - 2 === 1 ? t("CLASS") : t("CLASSES")}`}
        </p>
      )}
    </Fragment>
  );
};

export default MonthCalendarSchedules;
